'use client';

import { AttributeValuesFilterProps } from '../../models';
import { AttributeCheckboxFilter } from '../AttributeCheckboxFilter';

export const AttributeValuesFilter = ({ attribute, selection, draft, onSetValues }: AttributeValuesFilterProps) => {
    if (!attribute.options?.length || attribute.type === 'BOOLEAN') {
        return null;
    }

    return <AttributeCheckboxFilter attribute={attribute} selection={selection} draft={draft} onSetValues={onSetValues} />;
};
